<template>
    <b-modal
        id="modal-permission-access"
        size="md"
        hide-footer
        centered
        @hidden="onHideModal"
    >
        <template slot="modal-title">
            <h3 text>
                {{ $t('strategy.onepage.permissionAccess.permissions') }}
            </h3>
        </template>
        <div class="mt-2 mb-4">
            <span class="subtitle" text>{{
                $t('strategy.onepage.permissionAccess.makeAvailable')
            }}</span>
        </div>
        <div id="custom-multiselect" class="multiselect-container">
            <label class="m-0" for="multiselect" text>{{
                $t('strategy.onepage.permissionAccess.jobGroups')
            }}</label>
            <Multiselect
                id="multiselect"
                v-model="groupSelected"
                :placeholder="
                    $t(
                        'strategy.onepage.permissionAccess.multiselect.placeholder'
                    )
                "
                :select-label="
                    $t('strategy.onepage.permissionAccess.multiselect.select')
                "
                :selectedLabel="
                    $t('strategy.onepage.permissionAccess.multiselect.selected')
                "
                :deselectLabel="
                    $t('strategy.onepage.permissionAccess.multiselect.deselect')
                "
                label="name"
                track-by="id"
                :options="groupUpdate"
                :multiple="true"
            ></Multiselect>
        </div>
        <div v-if="idModal.blockId" class="info-content">
            <i class="fas fa-info-circle"></i>
            <span
                >{{ $t('strategy.onepage.permissionAccess.description') }}
            </span>
        </div>
        <div class="button-actions">
            <b-button variant="outline-primary" @click="onHideModal"
                >{{ $t('strategy.onepage.permissionAccess.cancel') }}
            </b-button>
            <b-button variant="primary" @click="isSubmiting"
                >{{ $t('strategy.onepage.permissionAccess.confirm') }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import Swal from 'sweetalert2'
import api from '@/services/api'
import StrategyService from '@/views/strategy/api'
import { success, danger } from '@/lib/notification'
export default {
    name: 'ModalPermission',
    components: {
        Multiselect,
    },
    data() {
        return {
            groups: [],
            groupSelected: [],
        }
    },
    computed: {
        ...mapState('strategy', {
            onepage: (state) => state.onepage,
            blocks: (state) => state.blocks,
        }),
        groupUpdate() {
            return this.groups.map((el) => {
                return {
                    name: el.name,
                    id: el.id,
                }
            })
        },
        groupSelectedIds() {
            return this.groupSelected.map((el) => {
                return el.id
            })
        },
        idModal() {
            return this.$route.query
        },
        selectedBlock() {
            return this.blocks.find((block) => {
                if (this.idModal.blockId == block.id) {
                    return block
                }
            })
        },
    },
    created() {
        this.getGroup()
        this.strategyService = new StrategyService()
    },
    mounted() {
        this.openModal()
        if (this.idModal.attributeId) {
            this.getGroupsSelected()
        }
    },
    methods: {
        ...mapActions('strategy', ['loadUnitysAndBlocks']),
        getGroup() {
            const params = {
                search: 'type:unit',
                with: 'groups',
            }
            api.get(`sections`, { params }).then(({ data }) => {
                this.groups = data.data[0].groups
            })
        },
        permissionModalOfAttribute() {
            this.strategyService
                .getAttributeId(this.idModal.attributeId, 'with=sections')
                .then(({ data }) => {
                    data.sections.forEach((group) => {
                        this.groupSelected.push({
                            id: group.id,
                            name: group.name,
                        })
                    })
                })
        },
        getGroupsSelected() {
            this.permissionModalOfAttribute()
        },
        isSubmiting() {
            const params = {
                occupation_group: this.groupSelectedIds,
            }
            if (this.idModal.blockId) {
                Swal.fire({
                    title: `${this.$t(
                        'strategy.onepage.permissionAccess.modal.title'
                    )}`,
                    text: `${this.$t(
                        'strategy.onepage.permissionAccess.modal.description'
                    )}`,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#009ada',
                    cancelButtonColor: '#Bec0c0',
                    cancelButtonText: `${this.$t(
                        'strategy.onepage.permissionAccess.modal.cancel'
                    )}`,
                    confirmButtonText: `${this.$t(
                        'strategy.onepage.permissionAccess.modal.confirm'
                    )}`,
                }).then((result) => {
                    if (result.value) {
                        return api
                            .put(
                                `one-page/block/${this.idModal.blockId}/attributes-visibility`,
                                params
                            )
                            .then(() => {
                                success(
                                    `${this.$t(
                                        'strategy.onepage.permissionAccess.modal.success'
                                    )}`
                                )
                                this.loadUnitysAndBlocks({
                                    id: this.onepage.id,
                                    data: 'with=sections;blocks;attributes',
                                })
                                this.onHideModal()
                            })
                            .catch((err) => {
                                console.log(err)
                                danger(
                                    `${this.$t(
                                        'strategy.onepage.permissionAccess.modal.danger'
                                    )}`
                                )
                                this.onHideModal()
                            })
                    }
                })
            }
            if (this.idModal.attributeId) {
                return api
                    .put(
                        `one-page/block/attribute/${this.idModal.attributeId}/visibility`,
                        params
                    )
                    .then(() => {
                        success(
                            `${this.$t(
                                'strategy.onepage.permissionAccess.modal.success'
                            )}`
                        )
                        this.loadUnitysAndBlocks({
                            id: this.onepage.id,
                            data: 'with=sections;blocks;attributes',
                        })
                        this.onHideModal()
                    })
                    .catch((err) => {
                        console.log(err)
                        danger(
                            `${this.$t(
                                'strategy.onepage.permissionAccess.modal.danger'
                            )}`
                        )
                        this.onHideModal()
                    })
            }
        },
        openModal() {
            this.$bvModal.show('modal-permission-access')
        },
        onHideModal() {
            this.groupSelected = []
            this.$router.go(-1)
            this.closeModal()
        },
        closeModal() {
            this.$bvModal.hide('modal-permission-access')
        },
    },
}
</script>

<style lang="sass" scoped>
[text]
    color: #444
    font-weight: bold
.subtitle
    font-size: 1rem
.info-content
    margin: 1rem 0 2rem
    font-size: .8rem
    color: #6E6E6E
    display: flex
    align-items: center
    column-gap: .5rem
.button-actions
    display: flex
    justify-content: center
    column-gap: 1rem
    margin: 1rem 0
</style>
